exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modalbox[data-v-885981e2] .el-dialog{min-width:550px}.selWidth[data-v-885981e2]{width:400px}.seachTiele[data-v-885981e2]{line-height:35px}.fa[data-v-885981e2]{color:#0a6aa1;display:block}.sheng[data-v-885981e2]{color:red;display:block}", ""]);

// exports
